import { useEffect } from "react";

const tier = {
  title: "See what Performance-Based Models could look like for your operation.",
  description:
    "A focused conversation with the Klexu team to scope your operation, surface the edge cases, and identify where governance design plus IoT-enabled performance measurement can ship the fastest path to a live outcome-based contract.",
  meta: "30 minutes · deep-dive · tailored playback",
  features: [
    "Comprehensive audit",
    "Custom strategy development",
    "Tool and platform recommendations",
    "Implementation timeline",
    "ROI projections",
    "Follow-up resources",
  ],
  calLink: "luis.prato/consulting-hour-30-min-meeting",
  namespace: "consulting-hour-30-min-meeting",
};

export const PricingTiers = () => {
  useEffect(() => {
    (function (C: any, A: string, L: string) {
      const p = function (a: any, ar: any) {
        a.q.push(ar);
      };
      const d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          const cal = C.Cal;
          // eslint-disable-next-line prefer-rest-params
          const ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api: any = function () {
              // eslint-disable-next-line prefer-rest-params
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === "string") {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ["initNamespace", namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    const Cal = (window as any).Cal;
    Cal("init", tier.namespace, { origin: "https://app.cal.com" });
    Cal.config = Cal.config || {};
    Cal.config.forwardQueryParams = true;
    Cal.ns[tier.namespace]("inline", {
      elementOrSelector: "#my-cal-inline-consulting-hour-30-min-meeting",
      config: { layout: "month_view", useSlotsViewOnSmallScreen: "true" },
      calLink: tier.calLink,
    });
    Cal.ns[tier.namespace]("ui", {
      hideEventTypeDetails: false,
      layout: "month_view",
    });
  }, []);

  return (
    <section className="py-10 md:py-12">
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto max-w-5xl">
        {/* Editorial intro */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground leading-tight mb-6">
            {tier.title}
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-6">
            {tier.description}
          </p>
          <p className="text-sm font-medium text-foreground">{tier.meta}</p>
        </div>

        {/* Inline feature row */}
        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-10 text-sm text-muted-foreground">
          {tier.features.map((feature) => (
            <li key={feature} className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-primary" />
              {feature}
            </li>
          ))}
        </ul>

        {/* Full-width embedded Cal.com */}
        <div className="rounded-2xl border border-border bg-card shadow-md overflow-hidden">
          <div
            id="my-cal-inline-consulting-hour-30-min-meeting"
            style={{ width: "100%", minHeight: "640px", overflow: "hidden" }}
          />
        </div>
      </div>
    </section>
  );
};
